import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { operatorFetchPage } from 'actions/operatorAction'
import { AvForm, AvInput } from 'availity-reactstrap-validation'
import { muatanPerOperator } from '../../actions/dashboardAction'
import { Row, Col, Card, CardHeader, CardBody, Button, FormGroup, InputGroup, InputGroupAddon, InputGroupText, CardFooter, Pagination, PaginationItem, PaginationLink, Progress } from 'reactstrap'

let isDefaultOperator = false
let isDefaultMonth = false
let thisMonth = moment().format('M')
let month_option = [
  { value: 1, label: 'Januari' },
  { value: 2, label: 'Februari' },
  { value: 3, label: 'Maret' },
  { value: 4, label: 'April' },
  { value: 5, label: 'Mei' },
  { value: 6, label: 'Juni' },
  { value: 7, label: 'Juli' },
  { value: 8, label: 'Agustus' },
  { value: 9, label: 'September' },
  { value: 10, label: 'Oktober' },
  { value: 11, label: 'November' },
  { value: 12, label: 'Desember' }
]

class MuatanPerOperator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 5,
      month: '',
      month_label: '',
      operator_id: '',
      operator_label: '',
    }

    this.selectMonth = this.selectMonth.bind(this)
    this.selectOperator = this.selectOperator.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 5,
      month: parseInt(thisMonth)
    }

    this.props.muatanPerOperator(data)
    this.props.operatorFetchPage()
  }

  componentWillUnmount() {
    isDefaultMonth = false
    isDefaultOperator = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        operator_id: this.state.operator_id,
      }

      if (this.state.month) {
        data.month = this.state.month
      } else {
        data.month = thisMonth
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 5) - 5
        data.start = offset
      }

      this.props.muatanPerOperator(data)
    }
  }

  selectMonth(opt) {
    if (opt) {
      this.setState({
        month: opt.value,
        month_label: opt.label
      })
    } else {
      this.setState({
        month: '',
        month_label: ''
      })
    }
  }

  selectOperator(opt) {
    if (opt) {
      this.setState({
        operator_id: opt.value,
        operator_label: opt.label
      })
    } else {
      this.setState({
        operator_id: '',
        operator_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    values.length = this.state.perPage

    if (this.state.month) {
      values.month = this.state.month
      isDefaultMonth = true
    } else {
      values.month = thisMonth
      isDefaultMonth = false
    }

    if (this.state.operator_id) {
      values.operator_id = this.state.operator_id
      isDefaultOperator = true
    } else {
      delete values.operator_id
      isDefaultOperator = false
    }

    this.props.muatanPerOperator(values)
  }

  render() {
    if (this.props.muatanPerOperatorIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.muatanPerOperatorHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }

  renderData() {
    if (this.props.muatanPerOperatorIsSuccess) {
      let defaultValues = {
        operator_id: this.state.operator_id,
        operator_label: this.state.operator_label,
        month: this.state.month,
        month_label: this.state.month_label,
      }

      const prevPage = parseInt(this.props.muatanPerOperatorData.currentPage) - 1
      const nextPage = parseInt(this.props.muatanPerOperatorData.currentPage) + 1

      let curPage = this.props.muatanPerOperatorData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.muatanPerOperatorData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { month } = this.state.month
      const defaultValueMonth = { label: defaultValues.month_label, value: defaultValues.month }
      const { operator_id } = this.state.operator_id
      const defaultValueOperator = { label: defaultValues.operator_label, value: defaultValues.operator_id }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Total realisasi muatan per operator</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Select name="month"
                        value={month}
                        isClearable
                        placeholder="Bulan..."
                        defaultValue={isDefaultMonth ? defaultValueMonth : false}
                        onChange={this.selectMonth}
                        options={month_option}
                        id="month"
                        inputId="input_month"
                        instanceId="instance_month"
                      />
                    </FormGroup>
                  </Col>
                  {this.props.operatorIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select name="operator_id"
                          value={operator_id}
                          isClearable
                          placeholder="Operator..."
                          defaultValue={isDefaultOperator ? defaultValueOperator : false}
                          onChange={this.selectOperator}
                          options={this.props.operators.options}
                          id="operator_id"
                          inputId="input_operator_id"
                          instanceId="instance_operator_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  <Col md="4">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1"><i className="fa fa-search"></i><span>Proses </span></Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody>
              {this.props.muatanPerOperatorData.data.length > 0 ? (
                this.props.muatanPerOperatorData.data.map((item, key) => (
                  <Card key={key}>
                    <CardBody>
                      <div>
                        <p>
                          Trayek <strong>{item.kode_trayek}</strong> - {item.nama_perusahaan_operator} <br />
                          <span>Voyage : <strong>{item.voyage}</strong></span> <br />
                          <span>Pelabuhan asal :<strong> {item.pelabuhan_asal}</strong> - Pelabuhan tujuan :<strong> {item.pelabuhan_tujuan} </strong></span>
                        </p>
                        <hr />
                        <h5>{item.nama_kapal}</h5>
                        <Progress value={item.percentage} className="mb-3"> {item.percentage}% Terpenuhi</Progress>
                      </div>
                    </CardBody>
                  </Card>
                ))
              ) : (<span>Data tidak ditemukan</span>)
              }
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.muatanPerOperatorData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.muatanPerOperatorData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.muatanPerOperatorData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.muatanPerOperatorData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.muatanPerOperatorData.pageTotal > 0 &&
                <p>Page: {this.props.muatanPerOperatorData.currentPage} of {this.props.muatanPerOperatorData.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div >
      )
    }
  }
}

MuatanPerOperator.propTypes = {
  muatanPerOperatorIsSuccess: PropTypes.bool.isRequired,
  muatanPerOperatorHasError: PropTypes.bool.isRequired,
  muatanPerOperatorIsLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    muatanPerOperatorData: state.dashboard.muatanPerOperatorData,
    muatanPerOperatorIsSuccess: state.dashboard.muatanPerOperatorSuccess,
    muatanPerOperatorHasError: state.dashboard.muatanPerOperatorError,
    muatanPerOperatorIsLoading: state.dashboard.muatanPerOperatorLoading,

    operators: state.operators.operators,
    operatorIsSuccess: state.operators.operatorGetSuccess,
    operatorHasError: state.operators.operatorGetError,
    operatorIsLoading: state.operators.operatorGetLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    muatanPerOperator: (data) => dispatch(muatanPerOperator(data)),
    operatorFetchPage: (data) => dispatch(operatorFetchPage(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MuatanPerOperator)